<template>
  <div>
    <button
      type="button"
      class="btn btn-primary"
      @click="showRequestModal"
    >
      Request Encashment
    </button>

    <div
      id="encashment_request_modal"
      class="modal fade"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Encashment Request
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              :disabled="submitting"
            />
          </div>
          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="submitEncashment">
              <div class="modal-body">
                <div class="mb-3">
                  <label
                    for="encash_days"
                    class="form-label"
                  >
                    No of days (Available: {{ availableBalance }}{{ pendingText }})
                  </label>
                  <ValidationProvider
                    v-slot="v"
                    name="Encash days"
                    :rules="`max_value:${availableBalance}|required|min_value:1`"
                  >
                    <input
                      id="encash_days"
                      v-model="encashDays"
                      v-no-wheel
                      class="form-control"
                      name="encash_days"
                      type="number"
                      step="0.5"
                    >

                    <span class="text-danger">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                  :disabled="submitting"
                >
                  Close
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="invalid || submitting"
                >
                  <div
                    v-if="submitting"
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  Save changes
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { Modal } from "bootstrap";
    import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
    import {min_value, max_value, integer, required} from "vee-validate/dist/rules";
    import { mapActions } from "vuex";

    extend('min_value', {
        ...min_value,
        message: 'The {_field_} must be greater than 1.'
    })
    extend('max_value', {
        ...max_value,
        message: 'The {_field_} must be less than current balance.'
    })
    extend('integer', {
        ...integer,
        message: 'The {_field_} must be an integer.'
    })
    extend('required', {
        ...required,
        message: 'The {_field_} is required.'
    })

    export default {
        name: 'EncashmentRequestButton',
        components: {
            ValidationObserver,
            ValidationProvider
        },
        props: {
            staffId: {
                type: Number,
                required: true
            },
            year: {
                type: Number,
                required: true
            },
            encashmentInfo: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            submitting: false,
            encashDays: 1
        }),
        computed: {
            requestModal() {
                return Modal.getOrCreateInstance(document.getElementById('encashment_request_modal'))
            },
            availableBalance() {
                return this.encashmentInfo.availableBalance ?? this.encashmentInfo.currentBalance
            },
            pendingText() {
                const pendingDays = this.encashmentInfo.pendingEncashDays || 0
                return pendingDays > 0 ? `, ${pendingDays} pending` : ''
            }
        },
        methods: {
            async submitEncashment(){
                this.submitting = true
                try {
                    await this.sendEncashmentRequest({
                        staff_id: this.staffId,
                        encash_days: this.encashDays,
                        year: this.year
                    })

                    await this.$emit('fetch-encashment-requested')
                    alert('Encashment request sent successfully')
                    this.requestModal.hide()
                } catch (e) {
                    const errorMessage = e.response?.data?.message || 'Something went wrong, please try again later'
                    alert(errorMessage)
                    console.error(e)
                } finally {
                    this.submitting = false
                }
            },
            showRequestModal() {
                this.requestModal.show();
            },
            ...mapActions({
                sendEncashmentRequest: 'vacation/sendEncashmentRequest',
            })
        }
    }
</script>
